import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const expectedRoles: string[] = route.data['expectedRoles'] || [];
    const allowedPmRoutes = ['/projects', '/burn'];
    return this.auth.userRole$.pipe(
      // Wait until the role is resolved (not null or undefined)
      filter((role) => role !== null && role !== undefined),
      map((role: string) => {
        // If on staging and user is a PM, restrict to /projects and /burn only
        // PMs and ELs: /projects and /burn
        if (
          (role === 'pm' || role === 'el') &&
          (window as any).environment?.restrictToDevOrGod === true
        ) {
          const currentPath = route.routeConfig?.path
            ? `/${route.routeConfig.path}`
            : '';
          if (allowedPmRoutes.includes(currentPath)) {
            return true;
          }
          this.router.navigate(['/unauthorized']);
          return false;
        }
        // ICs: /projects only (but /status is allowed for all below)
        if (
          role === 'ic' &&
          (window as any).environment?.restrictToDevOrGod === true
        ) {
          const currentPath = route.routeConfig?.path
            ? `/${route.routeConfig.path}`
            : '';
          if (currentPath === '/projects') {
            return true;
          }
          // fall through to allow /status for all
        }
        // Allow /status for all authenticated users
        const currentPath = route.routeConfig?.path
          ? `/${route.routeConfig.path}`
          : '';
        if (currentPath === '/status') {
          return true;
        }
        // Default logic for all other roles
        if (role && expectedRoles.includes(role)) {
          return true;
        }
        this.router.navigate(['/unauthorized']);
        return false;
      })
    );
  }
}
